import React, { useEffect, useState, useCallback } from 'react'
import { DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET } from '../../api/ApiConst';
import TableFilter from '../constants/TableFilter';
import TableAttributeAddEdit from './TableAttributeAddEdit';

const TableAttributes = (props) => {
    const [url, setUrl] = useState("");
    const [selectedTableId, setSelectedTableId] = useState(0)
    const [attributeDrawCount, setAttributeDrawCount] = useState(0);
    const [showAddModel, setShowAddModel] = useState(false);
    const [attributeObj, setAttributeObj] = useState({
        id: "",
        tableId: "",
        name: "",
        label: "",
        type: "",
        attributeLength: 255,
        tableViewAttribute: false,
        defaultValue: "",
        nullValue: false,
        autoIncrement: false,
        referenceTable: null,
        comment: "",
        formAttribute: true,
        defaultAttribute: false,
        unique: false,
        keyAttribute: null,
        valueAttribute: null,
        foreignKey: null,
        enumValues: null,
        referenceDataColumn: false,
        referenceWithMappingTable: false,
        mappingTableId: null,
        mappingTableName: null,
        currentTableParameterReferenceId: null,
        currentTableParameterReferenceName: null,
        referenceTableParameterReferenceId: null,
        referenceTableParameterReferenceName: null,
    });

    const toggleAddModel = () => {
        setShowAddModel(prev => !prev)
    }

    const handleTableAttributeAdd = () => {
        let rObj = {
            tableId: selectedTableId,
            name: "",
            label: "",
            type: "",
            attributeLength: 255,
            defaultValue: {},
            nullValue: true,
            autoIncrement: false,
            referenceTable: null,
            comment: "",
            formAttribute: true,
            tableViewAttribute: true,
            defaultAttribute: false,
            unique: false,
            keyAttribute: null,
            valueAttribute: null,
            foreignKey: null,
            enumValues: null,
            referenceDataColumn: false,
            referenceWithMappingTable: false,
            mappingTableId: null,
            mappingTableName: null,
            currentTableParameterReferenceId: null,
            currentTableParameterReferenceName: null,
            referenceTableParameterReferenceId: null,
            referenceTableParameterReferenceName: null,
        };
        setAttributeObj(rObj);
        toggleAddModel();
    }

    const handleAttributeEditData = (row) => {
        let rObj = {
            id: row.id,
            tableId: selectedTableId,
            name: row.name,
            type: row.type,
            label: row.label,
            attributeLength: row.attributeLength,
            defaultValue: row.defaultValue != null ? row.defaultValue : {},
            nullValue: row.nullValue,
            autoIncrement: row.autoIncrement,
            referenceTable: row.referenceTable === null ? null : row.referenceTable,
            comment: row.comment,
            formAttribute: row.formAttribute,
            tableViewAttribute: row.tableViewAttribute,
            defaultAttribute: row.defaultAttribute,
            unique: row.unique,
            keyAttribute: row.keyAttribute,
            valueAttribute: row.valueAttribute,
            foreignKey: row.foreignKey,
            enumValues: row.enumValues,
            referenceDataColumn: row?.referenceDataColumn,
            referenceWithMappingTable: row?.referenceWithMappingTable,
            mappingTableId: row?.mappingTableId,
            mappingTableName: row?.mappingTableName,
            currentTableParameterReferenceId: row?.currentTableParameterReferenceId,
            currentTableParameterReferenceName: row?.currentTableParameterReferenceName,
            referenceTableParameterReferenceId: row?.referenceTableParameterReferenceId,
            referenceTableParameterReferenceName: row?.referenceTableParameterReferenceName,
        };
        setAttributeObj(rObj);
        toggleAddModel();
    }

    useEffect(() => {
        if (props.id !== "" || props.id !== undefined) {
            setSelectedTableId(props.id);
            setUrl(DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET.replaceAll("{dynamic-table-id}", props.id));
        }
    }, [props]);

    const getTableAttributeList = useCallback(
        () => {
            return (
                <>
                    <div className='card'>
                        <div className='card-body p-0'>
                            <div className="row">
                                <div className="col-12  table-info">
                                    <div className="d-flex justify-content-center position-relative me-2">
                                        <h5 className='d-inline-block m-0'>Table {props.tableName} Attributes</h5>
                                        <button
                                            type="button"
                                            className="btn btn-primary border-0 new-attribute-btn"
                                            onClick={handleTableAttributeAdd}
                                        >
                                            Add New
                                        </button>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    {url !== "" &&
                                        <TableFilter
                                            tableName="table_attribute"
                                            tableUrl={url}
                                            paginationStatus={false}
                                            drawCount={attributeDrawCount}
                                            showRecordUpdateModel={handleAttributeEditData}
                                            refreshTableData={() => setAttributeDrawCount((pre) => (pre + 1))}
                                        />
                                        // <PaginationDataTable
                                        //     paginationUrl={url}
                                        //     search={true}
                                        //     paginationStatus={false}
                                        //     columns={attributeColumns} drawCount={attributeDrawCount} />
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </>
            )
        },
        [url, attributeDrawCount],
    );

    return (
        <>
            {getTableAttributeList()}
            {
                showAddModel &&
                <TableAttributeAddEdit
                    show={showAddModel}
                    close={toggleAddModel}
                    successCallBack={() => setAttributeDrawCount((pre) => (pre + 1))}
                    object={attributeObj}
                />
            }
        </>
    )
}

export default TableAttributes